// src/services/userManageService.js

import apiService from "./apiService";

// === CUSTOMERS ===
const getAllCustomers = () => apiService.getAll("backend/customers");


// Toggle enable/disable customer
const toggleCustomerStatus = (id) =>
  apiService.post(`backend/customers/${id}/toggle-status`);

// Create a new customer (admin registration)

 // Create a new customer (admin registration)
const createCustomer = (customerData) => {
  const formData = new URLSearchParams();

  formData.append("username", customerData.username.trim());
  formData.append("email", customerData.email.trim());
  formData.append("phone_number", customerData.phone_number.trim());
  formData.append("gender", customerData.gender);
  formData.append("password", customerData.password);

  console.log("Register customer request:", {
    username: customerData.username,
    email: customerData.email,
    phone_number: customerData.phone_number,
    gender: customerData.gender,
    password: "[REDACTED]",
  });

  return apiService.post(
    "backend/auth/register-user-admin",
    formData,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
    }
  );
};

// === EXPORT ===
const userManageService = {
  getAllCustomers,
  toggleCustomerStatus,
  createCustomer,
};

export default userManageService;
